export const replaceArrayIndex = <T>(oldArray: T[], idx: number, newContact: T): T[] =>
    oldArray.map((oldContact, oldContactIdx) => (oldContactIdx === idx ? newContact : oldContact));
